/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */

import React, { useState, useEffect } from 'react';
import {
  Modal, Button
} from 'antd';

const PartsModal = (props) => {
  const {
    modalVisible, hideModal, createDate, data
  } = props;
  const [newData, setNewData] = useState(false);
  const [tablehtml, setTablehtml] = useState('');

  const tableData = () => {
    const tableval = (
      <table className="logreport report-table">
        <thead className="ant-table-thead">
          <tr>
            <th rowSpan="2" className="ant-table-cell text-center">
              <div className="main-title py-2 me-2">
                MATERIAL
              </div>
            </th>
            <th rowSpan="2" className="ant-table-cell text-center">
              <div className="main-title py-2 me-2">
                QUANTITY
              </div>
            </th>
          </tr>
        </thead>
        <tbody className="ant-table-tbody">
          {
                  newData
                  && Object.keys(newData).map((e) => {
                    return (
                      <tr key={e} className="ant-table-row ant-table-row-level-0">
                        <td className="rTableCell text-center">{newData[e].material}</td>
                        <td className="rTableCell text-center">{newData[e].quantity}</td>
                      </tr>
                    );
                  })
                }
        </tbody>
      </table>
    );
    setTablehtml(tableval);
  };

  useEffect(() => {
    if (newData !== []) {
      tableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalVisible, newData]);

  useEffect(() => {
    const newData = [];
    data.map((item) => {
      item.createdAt = item.createdAt.replaceAll('/', '-');
      if (item.createdAt === createDate) {
        newData.push({ material: item.part_number, quantity: item.quantity });
      }
    });
    setNewData(newData);
  }, [createDate, data]);

  return (
    <>
      <Modal
        title="Parts Ordering Report"
        className="welds-modal"
        centered
        visible={modalVisible}
        width={1000}
        footer={[
          <Button key="submit" type="primary" onClick={() => hideModal()}>
            OK
          </Button>
        ]}
      >
        <div>
          <div className="ant-table scroll-table">
            <div className="ant-table-container">
              <div className="ant-table-content">
                {tablehtml}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PartsModal;
